import { BaseResource } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
export class LogEntryExcerptResource extends BaseResource {
    pk() {
        return this.id;
    }
}
LogEntryExcerptResource.urlRoot = legacyApiResourceUrl("Admin/LiveLogger/logs/{context}");
export class LogEntryResource extends BaseResource {
    pk() {
        return this.id;
    }
}
LogEntryResource.urlRoot = legacyApiResourceUrl("Admin/LiveLogger/logs/{context}/{id}");
export class LoggedMessage {
}
export class LoggedHeader {
}
export class LogStatement {
}
//# sourceMappingURL=LogEntryResource.js.map